module.exports = __webpack_public_path__ + "static/fonts/led.9d65f4e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/led.ttf
// module id = b2sX
// module chunks = 1